"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchedIngestTaskType = void 0;
var BatchedIngestTaskType;
(function (BatchedIngestTaskType) {
    BatchedIngestTaskType["PrepForMembersInTimeRange"] = "PrepForMembersInTimeRange";
    /**
     * Marks the current time range as processed. Called regardless of error in authorStep. (Which can use a catchHandler
     *  to notify or save unfinished list members.)
     */
    BatchedIngestTaskType["UpdateCursorTimeRange"] = "UpdateCursorTimeRange";
})(BatchedIngestTaskType = exports.BatchedIngestTaskType || (exports.BatchedIngestTaskType = {}));
//# sourceMappingURL=batched-ingest-processing.js.map